import React from 'react'
import { Col, Row } from 'antd'

import { Input, Switch as SwitchFormik } from 'src/components/Formik'
import { Text } from 'src/components/Ant'

export function SideModal({ formikProps }: any) {
  return (
    <>
      <Row gutter={[12, 0]}>
        <Col span={16}>
          <Input
            formikProps={formikProps}
            label="web.table.bedrooms.category.name"
            name="category"
            placeholder="web.table.bedrooms.category.placeholder"
            required={true}
          />
        </Col>
        <Col span={8}>
          <Input
            formikProps={formikProps}
            label="web.table.bedrooms.capacity.name"
            name="max_adults"
            placeholder="web.table.bedrooms.capacity.placeholder"
            required={true}
          />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Input
            formikProps={formikProps}
            label="web.table.bedrooms.comment.name"
            name="comments"
            placeholder="web.table.bedrooms.comment.placeholder"
            required={true}
          />
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <SwitchFormik
            checkedChildren={
              <Text title="web.resources.common.active" onlyText />
            }
            formikProps={formikProps}
            name="active"
            unCheckedChildren={
              <Text title="web.resources.common.inactive" onlyText />
            }
          />
        </Col>
      </Row>
    </>
  )
}
